module.exports = __webpack_public_path__ + "img/bg_logo.7a5030cf.png";